import { render, staticRenderFns } from "./escposPrinter.vue?vue&type=template&id=4d83be0c&scoped=true&"
import script from "./escposPrinter.vue?vue&type=script&lang=js&"
export * from "./escposPrinter.vue?vue&type=script&lang=js&"
import style0 from "./escposPrinter.vue?vue&type=style&index=0&id=4d83be0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83be0c",
  null
  
)

export default component.exports